(function () {
  "use strict";
  var STORAGE_KEY = "pe_fitment_vehicle";
  var treePromise = null;

  // FNY 2026-10-02: the vehicle tree is now built LIVE from product metafields
  // (custom.make / custom.model / custom.year_multi_selects) via the alternate
  // template templates/collection.fitment-data.liquid, so new or edited products
  // appear in the finder automatically. Models whose products carry no year list
  // get an "All Years" option. The static assets/fitment-tree.json stays as a fallback.
  var LIVE_URL = "/collections/all?view=fitment-data";
  var liveItems = null;

  function fetchLivePage(page, acc) {
    return fetch(LIVE_URL + "&page=" + page, { headers: { Accept: "application/json" } })
      .then(function (r) { if (!r.ok) throw new Error("live " + r.status); return r.text(); })
      .then(function (t) {
        var j = JSON.parse(t);
        acc = acc.concat(j.items || []);
        if (j.next && page < 20) return fetchLivePage(page + 1, acc);
        return acc;
      });
  }

  function itemsToTree(items) {
    var tree = {};
    items.forEach(function (it) {
      var mk = clean(it[0]), md = clean(it[1]), ys = it[2] || [];
      if (!mk || !md) return;
      if (!tree[mk]) tree[mk] = {};
      if (!tree[mk][md]) tree[mk][md] = [];
      if (!ys.length) { tree[mk][md].push("any"); return; }
      ys.forEach(function (y) { tree[mk][md].push(y); });
    });
    return tree;
  }

  function getTree(url) {
    if (treePromise) return treePromise;
    treePromise = fetchLivePage(1, [])
      .then(function (items) {
        if (!items.length) throw new Error("live empty");
        liveItems = items;
        return itemsToTree(items);
      })
      .catch(function () {
        liveItems = null;
        return fetch(url, { headers: { Accept: "application/json" } })
          .then(function (r) { if (!r.ok) throw new Error("tree " + r.status); return r.json(); });
      })
      .catch(function (e) { treePromise = null; throw e; });
    return treePromise;
  }

  // Exact client-side count from the live data (mirrors the collection filters:
  // a specific year only matches products that list that year).
  function liveCount(makeRaws, modelRaws, year) {
    if (!liveItems) return null;
    var mks = {}, mds = {};
    makeRaws.forEach(function (v) { mks[clean(v).toLowerCase()] = 1; });
    modelRaws.forEach(function (v) { mds[clean(v).toLowerCase()] = 1; });
    var n = 0;
    liveItems.forEach(function (it) {
      if (!mks[clean(it[0]).toLowerCase()] || !mds[clean(it[1]).toLowerCase()]) return;
      if (year === "any") { n++; return; }
      if ((it[2] || []).some(function (y) { return String(parseInt(y, 10)) === String(year); })) n++;
    });
    return n;
  }

  function yearPrefix(year) { return year && year !== "any" ? year + " " : ""; }

  // FNY 2026-10-02: acronym makes stored in title case in custom.make (e.g. "Gmc").
  var MAKE_DISPLAY = { gmc: "GMC", bmw: "BMW" };

  function clean(s) { return (s == null ? "" : String(s)).trim(); }

  function pickDisplay(variants) {
    return variants.slice().sort(function (a, b) {
      var la = (a.match(/[a-z]/g) || []).length;
      var lb = (b.match(/[a-z]/g) || []).length;
      if (lb !== la) return lb - la;
      if (a.length !== b.length) return a.length - b.length;
      return a.localeCompare(b);
    })[0];
  }

  function normalize(tree) {
    var makes = {};
    Object.keys(tree).forEach(function (rawMake) {
      var mk = clean(rawMake);
      if (!mk) return;
      var makeKey = mk.toLowerCase();
      if (!makes[makeKey]) makes[makeKey] = { rawSet: {}, models: {} };
      makes[makeKey].rawSet[mk] = 1;
      var models = tree[rawMake] || {};
      Object.keys(models).forEach(function (rawModel) {
        var md = clean(rawModel);
        if (!md) return;
        var modelKey = md.toLowerCase();
        var M = makes[makeKey].models;
        if (!M[modelKey]) M[modelKey] = { rawSet: {}, years: {} };
        M[modelKey].rawSet[md] = 1;
        (models[rawModel] || []).forEach(function (y) {
          if (y === "any") { M[modelKey].any = true; return; }
          var n = parseInt(y, 10);
          if (!isNaN(n)) M[modelKey].years[n] = 1;
        });
      });
    });
    var out = {};
    Object.keys(makes).forEach(function (mkKey) {
      var raws = Object.keys(makes[mkKey].rawSet);
      var modelsOut = {};
      var Mo = makes[mkKey].models;
      Object.keys(Mo).forEach(function (mdKey) {
        var mraws = Object.keys(Mo[mdKey].rawSet);
        var years = Object.keys(Mo[mdKey].years).map(Number).sort(function (a, b) { return a - b; });
        modelsOut[mdKey] = { display: pickDisplay(mraws), raws: mraws, years: years, any: !!Mo[mdKey].any };
      });
      out[mkKey] = { display: MAKE_DISPLAY[mkKey] || pickDisplay(raws), raws: raws, models: modelsOut };
    });
    return out;
  }

  function fillSelect(sel, items, placeholder) {
    sel.innerHTML = "";
    var opt = document.createElement("option");
    opt.value = ""; opt.textContent = placeholder;
    sel.appendChild(opt);
    items.forEach(function (it) {
      var o = document.createElement("option");
      o.value = it.value; o.textContent = it.label;
      sel.appendChild(o);
    });
  }

  function buildFilterParams(makeRaws, modelRaws, year) {
    var p = [];
    makeRaws.forEach(function (v) { p.push("filter.p.m.custom.make=" + encodeURIComponent(v)); });
    modelRaws.forEach(function (v) { p.push("filter.p.m.custom.model=" + encodeURIComponent(v)); });
    if (year && year !== "any") p.push("filter.p.m.custom.year_multi_selects=" + encodeURIComponent(year));
    return p.join("&");
  }

  function buildUrl(mode, handle, makeRaws, modelRaws, year, makeDisp, modelDisp) {
    if (mode === "search") {
      var q = [makeDisp, modelDisp].concat(year && year !== "any" ? [year] : []).join(" ");
      return "/search?q=" + encodeURIComponent(q) + "&type=product&options%5Bprefix%5D=last";
    }
    return "/collections/" + (handle || "all") + "?" + buildFilterParams(makeRaws, modelRaws, year);
  }

  // Live result count via the Section Rendering API (same mechanism the native
  // facets use). Returns a Promise<number>. Degrades gracefully on failure.
  function fetchCount(handle, params) {
    var u = "/collections/" + (handle || "all") + "?" + params;
    return fetch(u, { headers: { Accept: "text/html" } })
      .then(function (r) { if (!r.ok) throw new Error("count " + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var pc = doc.getElementById("ProductCount");
        if (pc) {
          var m = (pc.textContent || "").replace(/,/g, "").match(/\d+/);
          if (m) return parseInt(m[0], 10);
        }
        var items = doc.querySelectorAll("#product-grid .grid-item-block, #product-grid li.grid-item-block, .product-grid .grid-item-block");
        return items.length;
      });
  }

  function saveVehicle(v) { try { localStorage.setItem(STORAGE_KEY, JSON.stringify(v)); } catch (e) {} }
  function readVehicle() { try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || "null"); } catch (e) { return null; } }
  function clearVehicle() { try { localStorage.removeItem(STORAGE_KEY); } catch (e) {} }

  function initFinder(root) {
    var url = root.getAttribute("data-tree-url");
    var mode = root.getAttribute("data-result-mode") || "collection_filters";
    var handle = root.getAttribute("data-collection") || "all";
    var makeSel = root.querySelector("[data-fitment-make]");
    var modelSel = root.querySelector("[data-fitment-model]");
    var yearSel = root.querySelector("[data-fitment-year]");
    var submit = root.querySelector("[data-fitment-submit]");
    var status = root.querySelector("[data-fitment-status]");
    if (!makeSel || !modelSel || !yearSel || !submit) return;

    var countToken = 0;
    var submitLabel = (submit.textContent || "Find My Engine").trim();

    function setStatus(msg, state) {
      if (!status) return;
      status.textContent = msg || "";
      if (state) { status.setAttribute("data-state", state); }
      else { status.removeAttribute("data-state"); }
    }
    function reset(sel) { sel.disabled = true; sel.selectedIndex = 0; }

    reset(modelSel); reset(yearSel); submit.disabled = true;
    makeSel.disabled = true;
    setStatus("Loading vehicle data\u2026", "loading");

    function maybeCount() {
      var ok = !!(makeSel.value && modelSel.value && yearSel.value);
      submit.disabled = !ok;
      if (!ok) { setStatus(""); return; }
      var model = root._peModel;
      var mk = model[makeSel.value];
      var md = mk.models[modelSel.value];
      var year = yearSel.value;
      var label = yearPrefix(year) + mk.display + " " + md.display;
      if (mode !== "collection_filters") {
        setStatus("Ready \u2014 tap \u201c" + submitLabel + "\u201d to see results.", "success");
        return;
      }
      var myToken = ++countToken;
      setStatus("Checking availability\u2026", "loading");
      var lc = liveCount(mk.raws, md.raws, year);
      var countP = lc === null ? fetchCount(handle, buildFilterParams(mk.raws, md.raws, year)) : Promise.resolve(lc);
      countP.then(function (n) {
        if (myToken !== countToken) return;
        if (n > 0) {
          setStatus("\u2713 " + n + " engine" + (n === 1 ? "" : "s") + " fit your " + label + ". Tap \u201c" + submitLabel + "\u201d to view.", "success");
        } else {
          setStatus("No exact matches for " + label + ". Try a different year, or tap \u201c" + submitLabel + "\u201d to see the closest options.", "empty");
        }
      }).catch(function () {
        if (myToken !== countToken) return;
        setStatus(""); // graceful: no count available, Apply still works
      });
    }

    getTree(url).then(function (tree) {
      var model = normalize(tree);
      root._peModel = model;

      var makeItems = Object.keys(model).map(function (k) { return { value: k, label: model[k].display }; })
        .sort(function (a, b) { return a.label.localeCompare(b.label); });
      fillSelect(makeSel, makeItems, makeSel.getAttribute("data-placeholder") || "Make");
      makeSel.disabled = false;
      setStatus("");

      makeSel.addEventListener("change", function () {
        var mk = model[makeSel.value];
        reset(yearSel); submit.disabled = true; setStatus("");
        if (!mk) { reset(modelSel); return; }
        var items = Object.keys(mk.models).map(function (k) { return { value: k, label: mk.models[k].display }; })
          .sort(function (a, b) { return a.label.localeCompare(b.label); });
        fillSelect(modelSel, items, modelSel.getAttribute("data-placeholder") || "Model");
        modelSel.disabled = false;
      });

      modelSel.addEventListener("change", function () {
        var mk = model[makeSel.value]; submit.disabled = true; setStatus("");
        if (!mk || !mk.models[modelSel.value]) { reset(yearSel); return; }
        var mdl = mk.models[modelSel.value];
        var yrs = mdl.years.slice().sort(function (a, b) { return b - a; });
        var yItems = yrs.map(function (y) { return { value: String(y), label: String(y) }; });
        if (mdl.any || !yItems.length) yItems.push({ value: "any", label: "All Years" });
        fillSelect(yearSel, yItems, yearSel.getAttribute("data-placeholder") || "Year");
        yearSel.disabled = false;
        if (yItems.length === 1 && yItems[0].value === "any") { yearSel.value = "any"; maybeCount(); }
      });

      yearSel.addEventListener("change", maybeCount);

      var prev = readVehicle();
      if (prev && prev.mkKey && model[prev.mkKey]) {
        makeSel.value = prev.mkKey; makeSel.dispatchEvent(new Event("change"));
        if (prev.mdKey && model[prev.mkKey].models[prev.mdKey]) {
          modelSel.value = prev.mdKey; modelSel.dispatchEvent(new Event("change"));
          if (prev.year) { yearSel.value = String(prev.year); yearSel.dispatchEvent(new Event("change")); }
        }
      }
    }).catch(function () {
      setStatus("Vehicle data could not be loaded. Please try again later.", "error");
      makeSel.disabled = true;
    });

    function go() {
      var model = root._peModel; if (!model) return;
      var mk = model[makeSel.value]; if (!mk) return;
      var md = mk.models[modelSel.value]; if (!md) return;
      var year = yearSel.value; if (!year) return;
      var target = buildUrl(mode, handle, mk.raws, md.raws, year, mk.display, md.display);
      saveVehicle({ mkKey: makeSel.value, mdKey: modelSel.value, year: year, mk: mk.display, md: md.display, makeRaws: mk.raws, modelRaws: md.raws, mode: mode, handle: handle, url: target });
      setStatus("\u2713 Showing engines for " + yearPrefix(year) + mk.display + " " + md.display + "\u2026", "success");
      window.location.href = target;
    }

    submit.addEventListener("click", function (e) { e.preventDefault(); go(); });
    var form = root.querySelector("form");
    if (form) form.addEventListener("submit", function (e) { e.preventDefault(); go(); });
  }

  function initBanner(banner) {
    var v = readVehicle();
    var labelEl = banner.querySelector("[data-fitment-banner-label]");
    var shopBtn = banner.querySelector("[data-fitment-banner-shop]");
    var changeBtn = banner.querySelector("[data-fitment-banner-change]");
    var clearBtn = banner.querySelector("[data-fitment-banner-clear]");
    if (!v || !v.mk || !v.md || !v.year) { banner.hidden = true; return; }
    banner.hidden = false;
    if (labelEl) labelEl.textContent = yearPrefix(v.year) + v.mk + " " + v.md;
    if (shopBtn && v.url) shopBtn.setAttribute("href", v.url);
    if (changeBtn) changeBtn.addEventListener("click", function (e) {
      e.preventDefault();
      var f = document.getElementById("fitment-finder");
      if (f) { f.scrollIntoView({ behavior: "smooth", block: "start" }); }
      else { window.location.href = "/pages/find-your-engine#fitment-finder"; }
    });
    if (clearBtn) clearBtn.addEventListener("click", function (e) {
      e.preventDefault(); clearVehicle(); banner.hidden = true;
    });
  }

  function init() {
    var finders = document.querySelectorAll("[data-fitment-finder]");
    for (var i = 0; i < finders.length; i++) initFinder(finders[i]);
    var banners = document.querySelectorAll("[data-fitment-banner]");
    for (var j = 0; j < banners.length; j++) initBanner(banners[j]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else { init(); }
})();
